/* eslint-disable @typescript-eslint/no-var-requires */
const defaultTheme = require('tailwindcss/defaultTheme')
const colors = require('tailwindcss/colors')
const plugin = require('tailwindcss/plugin')

module.exports = {
  future: {
    purgeLayersByDefault: true,
    applyComplexClasses: true,
  },
  content: [
    './pages/**/*.{js,ts,jsx,tsx}',
    './pageFeatures/**/*.{js,ts,jsx,tsx}',
    './components/**/*.{js,ts,jsx,tsx}',
    './noissueUiKit/**/*.{js,ts,jsx,tsx}',
    './utils/**/*.{js,ts,jsx,tsx,mdx}',
    './stories/**/*.stories.{js,ts,jsx,tsx,mdx}',
    './app/**/*.{js,ts,jsx,tsx,mdx}',
  ],
  safelist: ['outline-none'],
  plugins: [
    require('@tailwindcss/container-queries'),
    require('@tailwindcss/line-clamp'),

    plugin(function ({ addUtilities }) {
      addUtilities({
        '.no-scrollbar': {
          '-ms-overflow-style': 'none',
          'scrollbar-width': 'none',
          '&::-webkit-scrollbar': {
            display: 'none',
          },
        },
        '.content-container': {
          width: '100%',
          'max-width': '1920px',
          'margin-left': 'auto',
          'margin-right': 'auto',
        },
        '.no-autofill-selection': {
          '-webkit-box-shadow': '0 0 0px 1000px #ffffff inset !important',
          'box-shadow': '0 0 0px 1000px #ffffff inset !important',
        },
        '.scrollbar-thin': {
          overflow: 'overlay',
          '&::-webkit-scrollbar': {
            width: '6px',
          },
          '&::-webkit-scrollbar-track': {
            background: '#f1f1f1',
            'border-radius': '3px',
          },
          '&::-webkit-scrollbar-thumb': {
            background: '#888',
            'border-radius': '3px',
            '&:hover': {
              background: '#555',
            },
          },
        },
        '.rotate-x-180': {
          transform: 'rotateX(180deg)',
        },
        '.appearance-textfield': {
          '-moz-appearance': 'textfield',

          '&::-webkit-inner-spin-button': {
            '-webkit-appearance': 'none',
          },
        },
        '.filter-pitaya': {
          filter:
            'brightness(0) saturate(100%) invert(46%) sepia(47%) saturate(7495%) hue-rotate(311deg) brightness(105%) contrast(101%)',
        },
        '.opaque-corners': {
          'mask-image': `linear-gradient(
            to right,
            rgba(255, 255, 255, 0),
            rgba(255, 255, 255, 1) 15%,
            rgba(255, 255, 255, 1) 85%,
            rgba(255, 255, 255, 0)
          )`,
        },
      })
    }),
  ],
  theme: {
    screens: {
      xxs: '375px',
      xs: '481px',
      ...defaultTheme.screens,
      '2lg': '1170px',
      '3xl': '1920px',
      '4xl': '2240px',
    },
    extend: {
      containers: {
        '8xl': '1024px',
        '9xl': '120rem',
        '10xl': '128rem',
        '11xl': '136rem',
        '12xl': '144rem',
      },
      screens: {
        print: { raw: 'print' },
      },
      maxWidth: {
        '8xl': '1920px',
      },
      backgroundImage: () => ({
        'account-arrow': 'url(/images/my-account/top-arrow.png)',
        cancel: 'url(/images/cancel.svg)',
        'eco-alliance': 'url(/images/eco-alliance.png)',
        'eco-alliance-hover': 'url(/images/eco-alliance-hover.png)',
        'eco-badge': 'url(/images/noissue-eco-badge.png)',
        hamburger: 'url(/images/hamburger.svg)',
        inspiration: 'url(/images/inspiration.png)',
        'inspiration-hover': 'url(/images/inspiration-hover.png)',
        'latest-order': 'url(/images/my-account/latest-order.png)',
        logout: 'url(/images/my-account/logout.png)',
        'my-account': 'url(/images/my-account/my-account.png)',
        'noissue-recommends': 'url(/images/noissue-recommends.png)',
        'noissue-recommends-hover': 'url(/images/noissue-recommends-hover.gif)',
        'order-panel': 'url(/images/order-panel.png)',
        'check-panel': 'url(/images/check-panel.png)',
        'creative-community': 'url(/images/creative-community.png)',
        'creative-community-hover': 'url(/images/creative-community-hover.png)',
        reorder: 'url(/images/my-account/reorder.png)',
        'the-wrap': 'url(/images/the-wrap.svg)',
      }),
      colors: {
        yellow: colors.amber,
        purple: colors.violet,
        primary: 'var(--primary)',
        'primary-2': 'var(--primary-2)',
        secondary: 'var(--secondary)',
        'secondary-2': 'var(--secondary-2)',
        hover: 'var(--hover)',
        'hover-1': 'var(--hover-1)',
        'hover-2': 'var(--hover-2)',
        'accents-0': 'var(--accents-0)',
        'accents-1': 'var(--accents-1)',
        'accents-2': 'var(--accents-2)',
        'accents-3': 'var(--accents-3)',
        'accents-4': 'var(--accents-4)',
        'accents-5': 'var(--accents-5)',
        'accents-6': 'var(--accents-6)',
        'accents-7': 'var(--accents-7)',
        'accents-8': 'var(--accents-8)',
        'accents-9': 'var(--accents-9)',
        violet: 'var(--violet)',
        'violet-light': 'var(--violet-light)',
        pink: 'var(--pink)',
        'pink-200': '#FFD6DE',
        'pink-400': '#FD566F',
        'pink-500': '#ED2D4A',
        pippin: '#FFDFE4',
        cyan: 'var(--cyan)',
        blue: 'var(--blue)',
        'blue-50': '#EBF4FA',
        indigo: '#393972',
        'indigo-50': '#F9F9FE',
        'indigo-300': '#A8A8D1',
        'indigo-600': '#49497A',
        lilac: '#D9D9E3',
        red: 'var(--red)',
        'red-50': '#FEF2F2',
        'red-400': '#F87171',
        'red-800': '#991B1B',
        green: '#39BD97',
        'green-50': '#ECFDF5',
        'green-400': '#34D399',
        'green-500': '#10B981',
        'green-800': '#065F46',
        'base-color': 'var(--base-color)',
        'base-color-2': 'var(--base-color-2)',
        'yellow-200': '#F8DEA1',
        'content-base': 'var(--content-base)',
        'green-base': 'var(--green-base)',
        'primary-text': 'var(--primary-text)',
        'accents-base-0': 'var(--accents-base-0)',
        'accents-base-1': 'var(--accents-base-1)',
        'accents-base-2': 'var(--accents-base-2)',
        'accents-base-3': 'var(--accents-base-3)',
        'accents-base-4': 'var(--accents-base-4)',
        'accents-base-5': 'var(--accents-base-5)',
        'accents-base-6': 'var(--accents-base-6)',
        'accents-base-7': 'var(--accents-base-7)',
        'accents-base-8': 'var(--accents-base-8)',
        'accents-base-9': 'var(--accents-base-9)',
        'accents-base-10': 'var(--accents-base-10)',
        'accents-base-11': 'var(--accents-base-11)',
        'accents-base-12': 'var(--accents-base-12)',
        'accents-base-13': 'var(--accents-base-13)',
        'accents-base-14': 'var(--accents-base-14)',
        'accents-base-15': 'var(--accents-base-15)',
        'accents-base-16': 'var(--accents-base-16)',
        'accents-base-17': 'var(--accents-base-17)',
        'accents-base-18': 'var(--accents-base-18)',
        'accents-base-19': 'var(--accents-base-19)',
        brown: 'var(--brown)',
        'light-blue': 'var(--light-blue)',
        'light-brown': 'var(--light-brown)',
        'light-brown2': 'var(--light-brown2)',
        'gray-dark': 'var(--gray-dark)',
        'gray-light': 'var(--gray-light)',
        'gray-light2': 'var(--gray-light2)',
        'gray-light3': 'var(--gray-light3)',
        'gray-light4': 'var(--gray-light4)',
        'gray-light5': 'var(--gray-light5)',
        'blue-light': 'var(--blue-light)',
        'success-green': 'var(--success-green)',
        'success-green-light': 'var(--success-green-light)',
        'prod-accent-1': 'var(--prod-accent-1)',
        'prod-accent-2': 'var(--prod-accent-2)',
        'prod-accent-3': 'var(--prod-accent-3)',
        'prod-accent-4': 'var(--prod-accent-4)',
        'prod-accent-5': 'var(--prod-accent-5)',
        'prod-accent-6': 'var(--prod-accent-6)',
        'prod-accent-7': 'var(--prod-accent-7)',
        'prod-accent-8': 'var(--prod-accent-8)',
        'prod-accent-9': 'var(--prod-accent-9)',
        'prod-accent-10': 'var(--prod-accent-10)',
        'prod-accent-11': 'var(--prod-accent-11)',
        'prod-accent-12': 'var(--prod-accent-12)',
        'prod-accent-13': 'var(--prod-accent-13)',
        'prod-accent-14': 'var(--prod-accent-14)',
        'prod-accent-15': 'var(--prod-accent-15)',

        /* noissue UI Kit */
        // Hero Colors
        acai: 'var(--acai-100)',
        unbleached: 'var(--unbleached-100)',

        // Accent colors
        pitaya: 'var(--pitaya-100)',
        bud: 'var(--bud-100)',
        forest: 'var(--forest-100)',
        starfruit: 'var(--starfruit-100)',
        rambutan: 'var(--rambutan-100)',

        // Utility Colors
        black: 'var(--black-100)',
        boulder: 'var(--boulder)',
        sand: 'var(--sand)',
        paper: 'var(--paper)',
        pebble: 'var(--pebble)',
        white: 'var(--white)',
        error: 'var(--error)',

        // Shades & tints
        'acai-120': 'var(--acai-120)',
        'acai-100': 'var(--acai-100)',
        'acai-80': 'var(--acai-80)',
        'acai-60': 'var(--acai-60)',
        'acai-40': 'var(--acai-40)',
        'acai-20': 'var(--acai-20)',
        'acai-5': 'var(--acai-5)',
        'unbleached-120': 'var(--unbleached-120)',
        'unbleached-100': 'var(--unbleached-100)',
        'unbleached-80': 'var(--unbleached-80)',
        'unbleached-60': 'var(--unbleached-60)',
        'unbleached-40': 'var(--unbleached-40)',
        'unbleached-20': 'var(--unbleached-20)',
        'unbleached-5': 'var(--unbleached-5)',
        'pitaya-120': 'var(--pitaya-120)',
        'pitaya-100': 'var(--pitaya-100)',
        'pitaya-80': 'var(--pitaya-80)',
        'pitaya-60': 'var(--pitaya-60)',
        'pitaya-40': 'var(--pitaya-40)',
        'pitaya-20': 'var(--pitaya-20)',
        'pitaya-5': 'var(--pitaya-5)',
        'bud-120': 'var(--bud-120)',
        'bud-100': 'var(--bud-100)',
        'bud-80': 'var(--bud-80)',
        'bud-60': 'var(--bud-60)',
        'bud-40': 'var(--bud-40)',
        'bud-20': 'var(--bud-20)',
        'bud-5': 'var(--bud-5)',
        'forest-120': 'var(--forest-120)',
        'forest-100': 'var(--forest-100)',
        'forest-80': 'var(--forest-80)',
        'forest-60': 'var(--forest-60)',
        'forest-40': 'var(--forest-40)',
        'forest-20': 'var(--forest-20)',
        'forest-5': 'var(--forest-5)',
        'starfruit-120': 'var(--starfruit-120)',
        'starfruit-100': 'var(--starfruit-100)',
        'starfruit-80': 'var(--starfruit-80)',
        'starfruit-60': 'var(--starfruit-60)',
        'starfruit-40': 'var(--starfruit-40)',
        'starfruit-20': 'var(--starfruit-20)',
        'starfruit-5': 'var(--starfruit-5)',
        'black-100': 'var(--black-100)',
        'black-80': 'var(--black-80)',
        'black-60': 'var(--black-60)',
        'black-40': 'var(--black-40)',
        'black-20': 'var(--black-20)',
        'black-10': 'var(--black-10)',
        'black-5': 'var(--black-5)',
        'rambutan-120': 'var(--rambutan-120)',
        'rambutan-100': 'var(--rambutan-100)',
        'rambutan-80': 'var(--rambutan-80)',
        'rambutan-60': 'var(--rambutan-60)',
        'rambutan-40': 'var(--rambutan-40)',
        'rambutan-20': 'var(--rambutan-20)',
        'rambutan-5': 'var(--rambutan-5)',

        // Old Branding
        // Primary
        'core-purple': 'var(--core-purple-90)',
        'core-purple-10': 'var(--core-purple-10)',
        'core-purple-20': 'var(--core-purple-20)',
        'core-purple-40': 'var(--core-purple-40)',
        'core-purple-80': 'var(--core-purple-80)',
        'core-purple-90': 'var(--core-purple-90)',
        'core-purple-100': 'var(--core-purple-100)',

        'core-rose': 'var(--core-rose-90)',
        'core-rose-10': 'var(--core-rose-10)',
        'core-rose-20': 'var(--core-rose-20)',
        'core-rose-40': 'var(--core-rose-40)',
        'core-rose-80': 'var(--core-rose-80)',
        'core-rose-90': 'var(--core-rose-90)',
        'core-rose-100': 'var(--core-rose-100)',

        'core-tree': 'var(--core-tree-90)',
        'core-tree-10': 'var(--core-tree-10)',
        'core-tree-20': 'var(--core-tree-20)',
        'core-tree-40': 'var(--core-tree-40)',
        'core-tree-80': 'var(--core-tree-80)',
        'core-tree-90': 'var(--core-tree-90)',
        'core-tree-100': 'var(--core-tree-100)',

        'core-grey-100': 'var(--core-grey-100)',
        'core-grey-90': 'var(--core-grey-90)',
        'core-grey-80': 'var(--core-grey-80)',
        'core-grey-70': 'var(--core-grey-70)',
        'core-grey-60': 'var(--core-grey-60)',
        'core-grey-50': 'var(--core-grey-50)',
        'core-grey-40': 'var(--core-grey-40)',
        'core-grey-30': 'var(--core-grey-30)',
        'core-grey-20': 'var(--core-grey-20)',
        'core-grey-10': 'var(--core-grey-10)',

        // Secondary
        'core-light-blue': 'var(--core-light-blue)',
        'core-white': 'var(--white)',
        'core-black': 'var(--black)',
        'core-beak': 'var(--core-beak)',
        'core-lilac': 'var(--core-lilac)',
        'core-beige': 'var(--core-beige)',
        'core-light-beige': 'var(--core-light-beige)',
        'core-error': 'var(--core-error)',
        'core-light-error': 'var(--core-light-error)',
        'core-blue-grey-light': 'var(--core-blue-grey-light)',

        /* Other old brand colors */
        'industry-navy': 'var(--industry-navy)',
        'industry-blue': 'var(--industry-blue)',
        'creative-yellow': 'var(--creative-yellow)',
        'creative-teal': 'var(--creative-teal)',
        'creative-purple': 'var(--creative-purple)',
        'eco-khaki': 'var(--eco-khaki)',
        'eco-dark-green': 'var(--eco-dark-green)',
        'eco-light-green': 'var(--eco-light-green)',

        // obselete - to be sunset
        'core-grey-darkest': 'var(--core-grey-90)',
        'core-grey-dark': 'var(--core-grey-80)',
        'core-grey-mild': 'var(--core-grey-60)',
        'core-grey-lighter': 'var(--core-grey-40)',
        'core-grey-light': 'var(--core-grey-30)',
        'core-grey-lightest': 'var(--core-grey-20)',
      },
      fontFamily: {
        sans: [
          'mori',
          '-apple-system',
          'system-ui',
          'BlinkMacSystemFont',
          'Helvetica Neue',
          'Helvetica',
          'sans-serif',
        ],
        mori: 'var(--font-mori)',
        plain: 'sans-serif',
      },
      letterSpacing: {
        mori: '-0.015em',
      },
      fontSize: {
        lg: ['1.2rem', '1.35'],
        xl: ['1.4rem', '1.55'],
        'base-16': ['1.6rem', '1.25'],
      },
      textColor: {
        base: 'var(--text-base)',
        primary: '#393972',
        secondary: '#EB2F4A',
      },
      boxShadow: {
        'outline-normal': '0 0 0 2px var(--accents-2)',
        magical:
          'rgba(0, 0, 0, 0.02) 0px 30px 30px, rgba(0, 0, 0, 0.03) 0px 0px 8px, rgba(0, 0, 0, 0.05) 0px 1px 0px',
        'outer-above': '0 0 0.2rem 0 rgb(0 0 0 / 30%)',
        normal: '0 0 1rem rgb(0 0 0 / 10%)',
        'legacy-modal': '10px 10px 0 0 var(--core-rose-90)',
        modal: '10px 10px 0 0 var(--pitaya-100)',
        'icon-button': '0px 0px 5px rgba(0, 0, 0, 0.1)',
      },
      lineHeight: {
        'extra-loose': '2.2',
      },
      inset: {
        108: '28rem',
      },
      scale: {
        120: '1.2',
      },
      height: {
        144: '36rem',
        168: '42rem',
        'order-break': '33vh',
      },
      minHeight: {
        174: '43.5rem',
      },
      width: {
        112: '30rem',
        120: '32rem',
        136: '38rem',
      },
      zIndex: {
        5: '5',
        2: '2',
        1: '1',
        0: '0',
        'above-zendesk-widget': '9999999',
        'modal-overlay': '10000000',
        modal: '10000001',
      },
      aspectRatio: {
        '4/3': '4 / 3',
      },
      borderRadius: {
        '4xl': '2rem',
      },
      keyframes: {
        slideDown: {
          from: { height: '0px', opacity: '0' },
          to: { height: 'var(--radix-accordion-content-height)', opacity: '1' },
        },
        slideUp: {
          from: {
            height: 'var(--radix-accordion-content-height)',
            opacity: '1',
          },
          to: { height: '0px', opacity: '0' },
        },
        slideInDown: {
          '0%': { transform: 'translateY(-20px)' },
          '100%': { transform: 'translateY(0px)' },
        },
        scrollLeft: {
          to: {
            left: '-100%',
          },
        },
      },
      animation: {
        slideDown: 'slideDown 300ms cubic-bezier(0.87, 0, 0.13, 1)',
        slideUp: 'slideUp 300ms cubic-bezier(0.87, 0, 0.13, 1)',
      },
    },
  },
}
